import { type LoadServerCxModuleOptions } from '@cx-modules/client';
import { fetchOffersDeliveryApiData } from '@cx-modules/offers-delivery-api-service';

import { type LoadOffersGroupedArgs } from '../../contract';

// This removed client helper resolved to the loader args without the separately supplied endpoint.
export type OffersRequestParams = Omit<LoadOffersGroupedArgs, 'dataApiEndpoint'>;

export const fetchOffersGroupedData = async (
  dataApiEndpoint = 'https://offers-delivery-api-stg.core.occloud.io', // Default to Stg if not provided
  params: OffersRequestParams,
  options: LoadServerCxModuleOptions | undefined = {},
) => {
  try {
    return await fetchOffersDeliveryApiData<OffersRequestParams>(dataApiEndpoint, params, options);
  } catch (error) {
    if (options.logger) {
      options.logger.error(error);
    }
    throw error;
  }
};

export const getOffersGroupedCacheKey = ({ apiKey, offerIds, vcId }: OffersRequestParams) => {
  const variantType = offerIds ? 'offerIds' : 'vcId';
  const ids = offerIds ? offerIds : vcId;
  return ['offers-grouped', apiKey, variantType, ids];
};
